export default __webpack_public_path__ + "static/media/fat_boy.95f00bcd.PNG";